import { SetStateAction } from "react";
import { Dispatch } from "react";
import { TrackObj } from "../../pages/MyTracks/types";
import { Track } from "../../proto/api_pb";
import { UploadCardStatusInfo, UploadedFileInfo } from "../FileUploadStatusCard/types";

export interface MyTrackControlsProps {
  tracks: TrackObj[];
  setSelectedTrack: Dispatch<SetStateAction<TrackObj[]>>;
  collaboratorsOptionsList: string[];
  allArtistList: string[];
  selectedTrack: TrackObj[];
  currentGenres: string[];
  bpmCache: Map<string, number | undefined>;
  handleClearFilters: () => void;
}

export interface MyTrackModalGroupProps {
  pageLoaded: boolean;
  modal: boolean;
  toggle: () => void;
  message: string;
  deleteConfirmModalOpen: boolean;
  closeDeleteConfirmModal: () => void;
  handleDeleteTrack: () => Promise<void>;
  openCollabsModal: boolean;
  handleCloseCollabsModal: () => void;
  trackToEdit: Track | undefined;
  open: boolean;
  handleClose: (isSuccessful?: boolean, statusMessage?: string) => void;
  trackToEditUrl: string;
  openBatchModal: boolean;
  openAddVersionModal: boolean;
  openAddTrackFileModal: boolean;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setUploadingFilesDetailsList: Dispatch<SetStateAction<UploadedFileInfo[]>>;
  setUploadingCardsStatusList: Dispatch<SetStateAction<UploadCardStatusInfo[]>>;
  handleFetch: () => Promise<void>;
}

export enum SORT_OPTIONS {
  TITLE = "Title",
  ARTIST = "Artist",
  LAST_MODIFIED = "Last Modified",
  DATE_CREATED = "Date Created",
}
